// extracted by mini-css-extract-plugin
export default {"root":"Basket-module_root_a148f9"};